import type { IObjectFormController } from './IObjectFormController'
import type { ObjectsService, PropertyValue } from '../services/ObjectsService'
import type { PropertyDefinitionModel, ObjectModel, ObjectTypeModel } from '@/core/gql/gql-models-override.ts'
import { BuiltInPropertyNames } from '@/objects/gql/object-type-gql-utils.ts'
import { isCorePropDef } from '@/object-types/services/ObjectTypesService.ts'

export class EditObjectController implements IObjectFormController {
  private object!: ObjectModel
  private type!: ObjectTypeModel
  private closePanelFn!: () => void
  private readonly propDefIdToValue = new Map<number, PropertyValue>()

  constructor(private readonly objectsService: ObjectsService) {}

  public init(params: { object: ObjectModel; type: ObjectTypeModel; closePanel: () => void }): void {
    this.object = params.object
    this.type = params.type
    this.closePanelFn = params.closePanel
    for (const [id, value] of params.object.propertyValues) {
      this.propDefIdToValue.set(id, value)
    }
  }

  public namePropDef(): PropertyDefinitionModel {
    return this.type.propertyDefinitions.find((x) => x.name === BuiltInPropertyNames.Name)!
  }

  public descrPropDef(): PropertyDefinitionModel {
    return this.type.propertyDefinitions.find((x) => x.name === BuiltInPropertyNames.Description)!
  }

  public getCustomPropDefs(): PropertyDefinitionModel[] {
    return this.type.propertyDefinitions.filter((x) => !x.isMeta && !isCorePropDef(x))
  }

  public getMetaPropDefs(): PropertyDefinitionModel[] {
    return this.type.propertyDefinitions.filter((x) => x.isMeta)
  }

  public getPropValue(propDefId: number): PropertyValue {
    return this.propDefIdToValue.get(propDefId) ?? null
  }

  public onPropValueChange(propDefId: number, value: PropertyValue): void {
    this.propDefIdToValue.set(propDefId, value)
    void this.objectsService.updateObjectProperty(this.object, propDefId, value)
    const updatedValues = new Map(this.object.propertyValues)
    updatedValues.set(propDefId, value)
    this.object = { ...this.object, propertyValues: updatedValues }
  }

  public onClose(): void {
    this.closePanelFn()
  }
}
